import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import ErrorBoundary from './components/ErrorBoundary';

import CssBaseline from '@mui/material/CssBaseline';
import GlobalStylesComponent from './theme/globalStyles';

import theme from '@/theme/index';
import Routes from '@/routes/index';

function App() {
  return (
    <StyledEngineProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStylesComponent />
        <SnackbarProvider maxSnack={3}>
          <ErrorBoundary />
          <Routes />
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
